import { object, number, z, string, array } from "zod";

import { UploadAttachResponseDTOSuccess } from "./UploadAttach.response.dto";

export const SendLetterQueryParams = object({
  ladyId: number(),
  letterText: string(),
  attachedFiles: array(UploadAttachResponseDTOSuccess),
});

export type SendLetterQueryParams = z.infer<typeof SendLetterQueryParams>;
